// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ToggleButton_toggle__3Mhm0","active":"ToggleButton_active__ULx5c"};